export const filter = (trainer, searchString) => {
	return [trainer.name, trainer.surname].find(s => s.includes(searchString));
};
